import { params } from "../../../hooks/game-room/handlegameRoom.js";
export const nightModeInitiated = () => {
  const { socket, setAdminAudioMuted, setAdminVideoMuted } = params;
  socket.on("nightModeInitiated", async () => {
    setAdminAudioMuted(true);
    setAdminVideoMuted(true);
  });
};
